import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Card from "../components/common/Card/Card";
import Footer from "../components/common/Footer/Footer";
const HomePage = () => {
    return (
        <>
            <div>
                <div
                    style={{
                        display: "flex",
                        padding: "5%",
                        justifyContent: "space-between",
                        flexDirection: "row",
                        backgroundColor: "white",
                    }}
                    className="Top_Area_Responsive"
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            marginTop: "4vh",
                        }}
                        className="Top_Area_Text_Left_Responsive"
                    >
                        <div
                            style={{
                                marginTop: "5vh",
                                fontSize: "50px",
                                width: "35vw",
                                cursor: "pointer",
                            }}
                        >
                            <span
                                className="underLine"
                                style={{
                                    fontFamily: " 'Ubuntu', sans-serif",
                                    fontWeight: "bolder",
                                }}
                            >
                                Ubuntu
                            </span>{" "}
                            <br />{" "}
                            <span
                                className="underLine1 Responsive_Head"
                                style={{
                                    fontFamily: "'Roboto Mono', monospace",
                                    fontWeight: "100",
                                }}
                            >
                                Making lifes better
                            </span>
                        </div>
                    </div>
                    <div className="Top_Area_Text_Right_Responsive">
                        <img src="/home_page.jpg" alt="helping image" />
                    </div>
                </div>
                <div style={{}}>
                    <Typography
                        style={{
                            width: "45vw",
                            fontSize: "30px",
                            margin: "auto",
                            textAlign: "center",
                            fontWeight: "lighter",
                        }}
                        variant="subtitle1"
                        color="initial"
                    >
                        Our aim is to help improve the quality of the day-to-day
                        lives of Alzheimer’s patients and their caregivers.
                        <br />
                        <Button variant="outlined" color="secondary">
                            Contact us
                        </Button>
                    </Typography>
                </div>
                <div className="vl">&nbsp;</div>
                <div className="vlt">
                    {" "}
                    {/* <span style={{ fontSize: '30px' }}>Tag Line</span> */}
                    {/* <br />
                    <span style={{ fontSize: "25px", fontWeight: "lighter" }}>
                        {" "}
                        Features
                    </span> */}
                </div>
            </div>
            <div
                className="CardsContainer"
                style={{
                    marginTop: "12vh",
                    marginBottom: "20vh",
                    padding: "4%",
                }}
            >
                <Card
                    src1="https://i.guim.co.uk/img/media/74b20219814a060d50033d702a80d8e42cd07188/0_34_5100_3060/master/5100.jpg?width=700&quality=85&auto=format&fit=max&s=d84b4f35ae6ba71faa0de4c58073bbf5"
                    src2="https://www.techlicious.com/images/phones/to-do-list-phone-700px.jpg"
                    caption1={"Record messages"}
                    caption2={"Keep track of your tasks"}
                />
                <Card
                    src1="https://ueno.co/static/6de8d4d5c9c9553938c4b4aa1a589b98/8fc1f/53f3f30d-b24d-4da9-ad4d-96cdf8c6292b_dropdbox-guide.webp"
                    src2="https://careclinic.io/wp-content/uploads/2021/11/Medication-Reminder-App-e1637301868577.png?p=171"
                    caption1={
                        "Browse through the patients submitted data/ progress"
                    }
                    caption2={"Reminder for medication and exercise"}
                />
                <Card
                    src1="https://i2.wp.com/blog.credo.com/wp-content/uploads/2021/11/engage_emergency_call_950x483.png"
                    src2="https://fscl01.fonpit.de/userfiles/7687254/image/NextPit_GPS_Google_Maps.jpg"
                    caption1={"Make emergency calls"}
                    caption2={
                        "Easier to record places and keep track of wherabouts"
                    }
                />
            </div>

            <Footer />
        </>
    );
};

export default HomePage;
